import React from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  Card,
  CardContent,

  Link as MuiLink,
  IconButton,
  useTheme,
  Slide,
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import EmailIcon from '@mui/icons-material/Email';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import CloseIcon from '@mui/icons-material/Close';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="down" ref={ref} {...props} />;
});



interface ContactUsModalProps {
  open: boolean;
  onClose: () => void;
}

export const ContactUsModal: React.FC<ContactUsModalProps> = ({ open, onClose }) => {
  const theme = useTheme();

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
        }
      }}
    >
      <Box sx={{ 
        background: `linear-gradient(135deg, ${theme.palette.primary.main}15 0%, ${theme.palette.primary.light}10 100%)`,
        p: 4,
        position: 'relative'
      }}>
        <IconButton 
          onClick={onClose} 
          sx={{ 
            position: 'absolute', 
            right: 12, 
            top: 12,
            bgcolor: 'rgba(255,255,255,0.9)',
            '&:hover': { bgcolor: 'white', transform: 'rotate(90deg)' },
            transition: 'all 0.3s'
          }}
        >
          <CloseIcon />
        </IconButton>
        
        <DialogContent sx={{ p: 0 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Box sx={{ 
              bgcolor: theme.palette.primary.main, 
              borderRadius: '50%', 
              p: 2,
              display: 'inline-flex',
              boxShadow: `0 8px 24px ${theme.palette.primary.main}40`,
              mb: 3
            }}>
              <ContactSupportIcon sx={{ fontSize: 48, color: 'white' }} />
            </Box>
            <Typography variant="h5" fontWeight={700} sx={{ mb: 1 }}>Contact Us</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
              Have questions? We're here to help
            </Typography>
          </Box>

          <Card 
            elevation={0}
            sx={{ 
              borderRadius: 2.5,
              border: '1px solid',
              borderColor: 'divider',
              transition: 'all 0.3s',
              '&:hover': {
                borderColor: theme.palette.primary.main,
                boxShadow: `0 4px 20px ${theme.palette.primary.main}20`,
              }
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2 }}>
                  Reach out to the COE Marketplace team
                </Typography>
                <Box 
                  display="flex" 
                  alignItems="center" 
                  justifyContent="center"
                  gap={1.5}
                  sx={{
                    bgcolor: `${theme.palette.primary.main}08`,
                    p: 2,
                    borderRadius: 2,
                  }}
                >
                  <EmailIcon sx={{ color: theme.palette.primary.main, fontSize: 24 }} />
                  <MuiLink 
                    href="mailto:aicoe.marketplace@epsilon.com" 
                    underline="hover" 
                    variant="body1"
                    sx={{ 
                      color: theme.palette.primary.main,
                      fontWeight: 600,
                    }}
                  >
                    aicoe.marketplace@epsilon.com
                  </MuiLink>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </DialogContent>
      </Box>
    </Dialog>
  );
};
